import React from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors } from '@myxplor/forms'
import SelectSessions from './sessions'
export { SelectSessionsNoAllowance } from './no-allowance'

export const validate = values => {
  if (!values.days || Object.keys(values.days).length === 0) {
    return false
  }

  const { days } = values
  for (const day in days) {
    if (days.hasOwnProperty(day)) {
      if (days[day].length > 0) {
        return true
      }
    }
  }
  return false
}

export const transformForAPI = values => {
  let payload = Object.assign({}, values, { educators: flattenSessions(values.days) })
  delete payload.days

  return payload
}

const flattenSessions = (sessions = {}) => {
  let output = []
  for (const day in sessions) {
    if (sessions.hasOwnProperty(day)) {
      output = output.concat(
        sessions[day].map(session => {
          session.date = day
          return session
        })
      )
    }
  }

  return output
}

const SelectSessionWrapper = props => {
  const { educators } = props

  if (educators.loading) {
    return <Loading>Loading educators</Loading>
  }

  if (educators.data.length === 0) {
    return <FormDisplayErrors errors="No educators to display" />
  }

  return <SelectSessions {...props} educators={educators.data} />
}

export default SelectSessionWrapper



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/select-session/index.js